import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { infoData } from "./infoenum";
import {
  metersToFeet,
  getFormattedNumber
} from '../../../../../../common/utils'

class ThreerowSubtest extends React.Component {
  constructor(props) {
    super(props);
  }

  formatNumber = number => {
    if (
      (number.toString().split(".")[0] &&
        number.toString().split(".")[0].length > 9) ||
      (number.toString().split(".")[1] &&
        number.toString().split(".")[1].length > 6)
    ) {
      return number.toExponential(3).toUpperCase();
    } else return number;
  };

  lengthUnitConverter = (length) => {
    const { chartMeasurementUnit } = this.props
    if (chartMeasurementUnit === 'feet') {
      return metersToFeet(length)
    }
    let formattedNum = getFormattedNumber(length)
    return (formattedNum) ? parseFloat(formattedNum) : 0
  }

  render() {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit,
      subtestResultsDisplay,
      subtest,
      subtestRes
    } = this.props;

    let isNavitekResult = results && results.data && results.data.device && results.data.device.includes("NaviTEK");

    switch (subtest) {
      case "fiberlengthloss":
        let supportedstandards = ""
        let nolimits = false
        if (results.data.subtests[subtest]) {
          const maxLenth = 40;
          supportedstandards = results.data.subtests[subtest].supportedstandards
          nolimits = (supportedstandards == "None") ? true : false
          if (supportedstandards.length > maxLenth) {
            supportedstandards = supportedstandards.substring(0, Math.min(maxLenth, supportedstandards.length)) + "..."
          }
        }
        return (
          <Grid container spacing={0}>
            {isNavitekResult ? (<Grid xs={12} className={classes.emptyGrid}></Grid>) :
              (<Grid xs={12} className={classes.topGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_supported_standards").toUpperCase()}
              </Typography>
              <Typography className={classes.t_tar_text}>
                {supportedstandards}
              </Typography>
            </Grid>)}
            <Grid xs={12} className={isNavitekResult ? classes.emptyGrid : classes.middleGrid}>
              <Typography className={classes.t_tar_text}>
                {isNavitekResult ? translate("result_length_2") : translate("result_length_limit") + ((chartMeasurementUnit === 'feet') ? "" : " (m)")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  this.lengthUnitConverter(results.data.subtests[subtest].length) + (!isNavitekResult ? (" / " + (nolimits ? "-" : this.lengthUnitConverter(results.data.subtests[subtest].maxlength))) : "")}
              </Typography>
            </Grid>
            {!isNavitekResult && (
            <Grid xs={12} className={classes.bottomGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_insloss_limit") + " (dB)"}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].insertionloss.toFixed(2) + " / " + (nolimits ? "-" : results.data.subtests[subtest].losslimit.toFixed(2))}
              </Typography>
            </Grid>
          )}
          </Grid>
        );
      case "poeload":
        return (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.topGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("chart_line_standard").toUpperCase()}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].standard}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.middleGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("class")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].poeclass}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.bottomGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("power")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].power}
              </Typography>
            </Grid>
          </Grid>
        );
      case "webdata":
        return (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.topGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_test_duration2").toUpperCase()}
              </Typography>
              <Typography className={classes.t_tar_no3}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].duration}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.middleGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_link_speed")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                infoData.find(
                  o => o.id === results.data.subtests[subtest].linkspeed
                )
                  ? infoData.find(
                      o => o.id === results.data.subtests[subtest].linkspeed
                    ).name
                  : ""}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.bottomGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_no_of_web_sessions2").toUpperCase()}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].sessions}
              </Typography>
            </Grid>
          </Grid>
        );
      case "voipdata":
        return (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.topGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_test_duration2").toUpperCase()}
              </Typography>
              <Typography className={classes.t_tar_no3}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].duration}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.middleGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_link_speed")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                infoData.find(
                  o => o.id === results.data.subtests[subtest].linkspeed
                )
                  ? infoData.find(
                      o => o.id === results.data.subtests[subtest].linkspeed
                    ).name
                  : ""}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.bottomGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_no_of_voip_calls2").toUpperCase()}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].calls}
              </Typography>
            </Grid>
          </Grid>
        );
      case "videodata":
        return (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.topGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_test_duration2").toUpperCase()}
              </Typography>
              <Typography className={classes.t_tar_no3}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].duration}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.middleGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_link_speed")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                infoData.find(
                  o => o.id === results.data.subtests[subtest].linkspeed
                )
                  ? infoData.find(
                      o => o.id === results.data.subtests[subtest].linkspeed
                    ).name
                  : ""}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.bottomGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_no_of_video_streams2").toUpperCase()}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].streams}
              </Typography>
            </Grid>
          </Grid>
        );
      case "cctvdata":
        return (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.topGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_test_duration2").toUpperCase()}
              </Typography>
              <Typography className={classes.t_tar_no3}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].duration}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.middleGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_link_speed")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                infoData.find(
                  o => o.id === results.data.subtests[subtest].linkspeed
                )
                  ? infoData.find(
                      o => o.id === results.data.subtests[subtest].linkspeed
                    ).name
                  : ""}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.bottomGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("subtest_number_of_cameras2")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].cameras}
              </Typography>
            </Grid>
          </Grid>
        );
      case "netscan":
        return (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.topGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_scan_range")}
              </Typography>
              <Typography className={classes.t_tar_no3}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].scanrange}
              </Typography>
            </Grid>

            <Grid xs={6} className={classes.middleLGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_ipv4_hosts")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].ipv4host}
              </Typography>
            </Grid>
            <Grid xs={6} className={classes.middleRGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_ipv6_hosts")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].ipv6host}
              </Typography>
            </Grid>

            <Grid xs={12} className={classes.bottomGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("address_conflicts2") + ":"}
              </Typography>
              <Typography className={classes.t_tar_no3}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].addressconflict}
              </Typography>
            </Grid>
          </Grid>
        );
      case "customdata":
        return (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.topGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_test_duration2").toUpperCase()}
              </Typography>
              <Typography className={classes.t_tar_no3}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].duration}
              </Typography>
            </Grid>

            <Grid xs={6} className={classes.middleLGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_link_speed")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                infoData.find(
                  o => o.id === results.data.subtests[subtest].linkspeed
                )
                  ? infoData.find(
                      o => o.id === results.data.subtests[subtest].linkspeed
                    ).name
                  : ""}
              </Typography>
            </Grid>
            <Grid xs={6} className={classes.middleRGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_total_bandwidth").toUpperCase()}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].totalbandwidth.toFixed(1) +
                    " Gb/s"}
              </Typography>
            </Grid>

            <Grid xs={12} className={classes.bottomGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("error_limit")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  (results.data.subtests[subtest].errorcount != null
                    ? this.formatNumber(
                        results.data.subtests[subtest].errorcount
                      )
                    : "") +
                    " / " +
                    (results.data.subtests[subtest].losslimitcount != null
                      ? this.formatNumber(
                          results.data.subtests[subtest].losslimitcount
                        )
                      : "")}
              </Typography>
            </Grid>
          </Grid>
        );
    }
  }
}

export default withStyles(styles)(ThreerowSubtest);
